package co.torvus.web

import react.create
import react.dom.client.createRoot
import web.dom.ElementId
import web.dom.document

fun main() {
    val container = document.getElementById(ElementId("root"))
        ?: error("Couldn't find #root container to render into")
    createRoot(container).render(App.create())
}
